const permissions = {
  ARC_RECORDS_EXCHANGE: {
    context: 'ARC',
    permissions: ['ViewRecordsExchange'],
  },
  AUDIT_PROJECTS: {
    context: 'LightyearContext',
    permissions: ['LightyearAuditProjectsPermission'],
  },
  CAMERA_OPERATOR: {
    context: 'LightyearContext',
    permissions: ['LightyearCameraOperatorDashboardOprPermission'],
  },
  CAMERA_OPERATOR_FEEDBACK: {
    context: 'LightyearContext',
    permissions: ['LightyearCameraOperatorFeedbackPermission'],
  },
  CAMERA_OPERATOR_MANAGEMENT: {
    context: 'LightyearContext',
    permissions: ['LightyearCameraOperatorMgmtPermission'],
  },
  CAMERA_OPERATOR_MANAGER: {
    context: 'LightyearContext',
    permissions: ['LightyearCameraOperatorDashboardMgrPermission'],
  },
  CONTRACTOR_SUPERVISOR: {
    context: 'LightyearContext',
    permissions: ['LightyearContractorSupervisorPermission'],
  },
  FILE_MANAGER: {
    context: 'INGEST_SYSTEM_CONTEXT',
    permissions: ['INGEST_SYSTEM_ALL_PERM'],
  },
  FINANCE_REVIEW: {
    context: 'LightyearContext',
    permissions: ['LightyearFinanceReviewPermission'],
  },
  IMAGE_ORGANIZE: {
    context: 'LightyearContext',
    permissions: ['LightyearImageOrganizePermission'],
  },
  INTERNAL_SEARCH: {
    context: 'LightyearContext',
    permissions: ['LightyearInternalSearchPermission'],
  },
  LIGHTYEAR_ADMIN: {
    context: 'LightyearContext',
    permissions: ['LightyearAdminPermission'],
  },
  RECORD_METADATA_REVIEW: {
    context: 'LightyearContext',
    permissions: ['LightyearRecordMetadataReviewPermission'],
  },
  RECORDS_HOME: {
    context: 'LightyearContext',
    permissions: ['LightyearRecordsHomePermission'],
  },
  RFP_PERMISSION: {
    context: 'LightyearContext',
    permissions: ['LightyearRfpPermission'],
  },
  RMS_ADMIN: {
    context: 'RMSContext',
    permissions: ['RMSAdminPermission'],
  },
  RMS_ARTIFACT_WRITE: {
    context: 'RMSContext',
    permissions: ['RMSArtifactWritePermission'],
  },
  RMS_GROUP_READ: {
    context: 'RMSContext',
    permissions: ['RMSGroupReadPermission'],
  },
  RMS_GROUP_WRITE: {
    context: 'RMSContext',
    permissions: ['RMSGroupWritePermission'],
  },
  SUPERVISE_CAMERA_PROJECTS: {
    context: 'LightyearContext',
    permissions: ['LightyearSuperviseCameraProjectsPermission'],
  },
  VIEW_CAMERA_PROJECTS: {
    context: 'LightyearContext',
    permissions: ['LightyearViewCameraProjectsPermission'],
  },
  WATERMARKING_PERMISSION: {
    context: 'LightyearContext',
    permissions: ['LightyearWatermarkingPermission'],
  },
}

const rmsReadPermissions = (any) => any(permissions.RMS_ADMIN, permissions.RMS_GROUP_READ)
const rmsWritePermissions = (any) => any(permissions.RMS_ADMIN, permissions.RMS_GROUP_WRITE)

export const arcRecordsExchange = ({ all }) => all(permissions.ARC_RECORDS_EXCHANGE)

export const audit = ({ all }) =>
  all(permissions.AUDIT_PROJECTS, permissions.RMS_ARTIFACT_WRITE, permissions.RMS_GROUP_WRITE)

export const authorized = () => Promise.resolve(true)

export const cameraDashboard = ({ all, any }) =>
  all(any(permissions.SUPERVISE_CAMERA_PROJECTS, permissions.VIEW_CAMERA_PROJECTS), rmsReadPermissions(any))

export const cameraOperator = ({ all, any }) => all(permissions.CAMERA_OPERATOR, rmsReadPermissions(any))

export const cameraOperatorFeedback = ({ all, any }) =>
  all(permissions.CAMERA_OPERATOR_FEEDBACK, rmsReadPermissions(any))

export const cameraOperatorManagement = ({ all }) => all(permissions.CAMERA_OPERATOR_MANAGEMENT)

export const cameraOperatorManager = ({ all, any }) => all(permissions.CAMERA_OPERATOR_MANAGER, rmsReadPermissions(any))

export const contractInvoiceReview = ({ all }) => all(permissions.FINANCE_REVIEW)

export const contractorSupervisor = ({ all }) => all(permissions.CONTRACTOR_SUPERVISOR)

export const imageOrganize = ({ all }) => all(permissions.IMAGE_ORGANIZE)

export const internalSearch = ({ all }) => all(permissions.INTERNAL_SEARCH)

export const lightyearAdmin = ({ all }) => all(permissions.LIGHTYEAR_ADMIN)

export const oldCameraOperatorFeedback = ({ all, any }) =>
  all(permissions.FILE_MANAGER, permissions.RECORDS_HOME, rmsReadPermissions(any))

export const recordMetadataReview = ({ all }) => all(permissions.RECORD_METADATA_REVIEW)

export const recordsHome = ({ all }) => all(permissions.RECORDS_HOME)

export const rfp = ({ all }) => all(permissions.RFP_PERMISSION)

export const shippingAddress = ({ any }) => any(permissions.SUPERVISE_CAMERA_PROJECTS, permissions.VIEW_CAMERA_PROJECTS)

export const superviseCameraProjects = ({ all }) => all(permissions.SUPERVISE_CAMERA_PROJECTS)

export const viewCameraProjects = ({ all }) => all(permissions.VIEW_CAMERA_PROJECTS)

export const volumeSetImageOrganize = ({ all, any }) => all(permissions.IMAGE_ORGANIZE, rmsWritePermissions(any))

export const watermarking = ({ all }) => all(permissions.WATERMARKING_PERMISSION)
